<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Kategori Listesi">
          <b-alert variant="warning" show class="mb-0">
            <div class="alert-body mb-2">
              <span
                ><strong>Not:</strong> Eklenecek içerik adı ve arama motoru
                bağlantı linki benzersiz olmalıdır...</span
              >
            </div>
          </b-alert>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Kategoriler">
          <b-form>
            <b-row>
              <b-col cols="12">
                <BaseTree :indent="50" :treeData="categoriesTree">
                  <template v-slot="{ node }">
                    <b-card
                      :border-variant="'primary'"
                      bg-variant="transparent"
                      class="shadow-none draggable-card"
                    >
                      <b-row>
                        <b-col cols="4">
                          <b-card-text
                            class="font-weight-bold mb-0"
                            style="line-height: 36px"
                          >
                            {{ node.text }}
                          </b-card-text>
                        </b-col>
                        <b-col cols="8">
                          <div class="float-right">
                            <b-button-group>
                              <b-button
                                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                variant="outline-primary"
                                class="btn-icon rounded-circle"
                                @click="createAction(node)"
                              >
                                <feather-icon icon="PlusIcon" />
                              </b-button>
                            </b-button-group>
                          </div>
                          <div class="float-right">
                            <b-badge class="mr-2" style="margin-top: 5px;" variant="light-primary">
                              İçerik Sayısı: {{ node.contentCount }}
                            </b-badge>
                          </div>
                        </b-col>
                      </b-row>
                    </b-card>
                  </template>
                </BaseTree>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Ripple from "vue-ripple-directive";
import "he-tree-vue/dist/he-tree-vue.css";
import { BaseTree, Draggable } from "@he-tree/vue2";
import {
  BRow,
  BCol,
  BImg,
  BCard,
  BForm,
  BBadge,
  BAlert,
  BButton,
  BAvatar,
  BCardText,
  BButtonGroup,
  BListGroupItem,
  BButtonToolbar,
} from "bootstrap-vue";

import { Endpoints } from "@core/endpoints/endpoints";
const endpoints = new Endpoints();

export default {
  components: {
    BRow,
    BCol,
    BImg,
    BCard,
    BForm,
    BBadge,
    BAlert,
    BButton,
    BAvatar,
    BCardText,
    BButtonGroup,
    BListGroupItem,
    BButtonToolbar,
    BaseTree,
    Draggable,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      request: [],
      categoriesTree: [],
    };
  },
  watch: {},
  methods: {
    createAction(node) {
      this.$router.push({
        path: `/contents/categories/${node.slug}`,
      });
    },
  },
  mounted() {
    endpoints
      .getCategoriesTree(null, this.$i18n.locale, () => {})
      .then((data) => {
        this.categoriesTree = [];
        this.categoriesTree = [...data.response];
      })
      .catch((err) => {
        console.log(err);
      });
  },
};
</script>
<style>
.draggable-card {
  margin-bottom: 0;
}
.draggable-card > .card-body {
  padding: 10px;
}

.draggable-card > .card-body > .card-title {
  margin-bottom: 0;
  font-size: 1rem;
}
.tree-node {
  border: 0 !important;
}
</style>
